import React from "react";

const Property = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        G.
        <span className="text-[#01A7D1] "> INTELLECTUAL PROPERTY RIGHTS</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. Yostel owns or holds the Licenses to all Data and Marks on the
          Platform
        </h1>
        The content on the Platform (exclusive of all Submitted Content),
        including without limitation, the text, software, scripts, graphics,
        photos, sounds, music, videos, interactive features and the like
        ("Data") and the trademarks, service marks and logos contained therein
        ("Marks"), are owned by Yostel. Other trademarks, names and logos on
        Platform are the property of their respective owners.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Data on the Platform is provided to you as is for your information and
        personal use only and may not be used, copied, reproduced, distributed,
        transmitted, broadcast, displayed, sold, licensed, or otherwise
        exploited for any other purposes whatsoever without the prior written
        consent of the respective owners. Yostel reserves all rights not
        expressly granted in and to the Platform and the Data. You agree not to
        use, copy, or distribute, any of the Data other than as expressly
        permitted herein, including any use, copying, or distribution of
        Submitted Content obtained through the Platform for any commercial
        purposes. If you download or print a copy of the Data for personal use,
        you must retain all copyright and other proprietary notices contained
        thereon. You agree not to circumvent, disable or otherwise interfere
        with security features of the Platform or features that prevent or
        restrict use or copying of any Data or enforce limitations on use of the
        Platform or the Data therein.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. Yostel's License to You for the Use of Data and Marks
        </h1>
        The Platform contains Yostel's Data and Marks, which are, or may become,
        protected by copyright, trademark, patent, trade secret and other laws,
        and Yostel owns and retains all rights in the Yostel Data and Marks.
        Subject to these Terms of Use, Yostel hereby grants you a limited,
        revocable, non-transferable, no sublicensable license to reproduce and
        display the Yostel Data (excluding any software source code) solely for
        your personal use in connection with accessing and participating in the
        Platform. The Platform may also contain Data of other users or
        licensors, which you shall not copy, modify, translate, publish,
        broadcast, transmit, distribute, perform, display, or sell.
      </p>
    </div>
  );
};

export default Property;
